import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import header from './../../../../../images/desktop/header.png';


export const HeaderImage: React.FC = () => {
  return (
    <AnimatePresence>
      <motion.div animate={{ scale: [1, 1.02, 1] }} transition={{ duration: 0.3 }}>
        <img style={{ width: '100%' }} src={header} alt=''></img>
      </motion.div>
    </AnimatePresence>
  );
};
